import { render, staticRenderFns } from "./TreeGrupo.vue?vue&type=template&id=e47b1076&scoped=true&"
import script from "./TreeGrupo.vue?vue&type=script&lang=js&"
export * from "./TreeGrupo.vue?vue&type=script&lang=js&"
import style0 from "./TreeGrupo.vue?vue&type=style&index=0&id=e47b1076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b1076",
  null
  
)

export default component.exports